export const SET_RUNNING_TRIPS = 'SET_RUNNING_TRIPS';

export const actionSetRunningTrips = trips => ({
    type: SET_RUNNING_TRIPS,
    payload: trips
})
